import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SEOStructuredData() {
  const [injected, setInjected] = useState(false);

  useEffect(() => {
    if (injected) return;
    
    (async () => {
      try {
        const res = await axios.get(`${API}/structured-data/events`);
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "seo-events-jsonld";
        script.textContent = JSON.stringify(res.data);
        
        // Remove old one if exists
        const existing = document.getElementById("seo-events-jsonld");
        if (existing) existing.remove();
        
        document.head.appendChild(script);
        setInjected(true);
      } catch (error) {
        console.error("Failed to load structured data:", error.message);
      }
    })();
  }, [injected]);

  return null;
}
